import { Nomenclature } from './Nomenclature';
import { Person } from './Person';
import { FrxBaseBean } from './frxbasebean';
export class CaseSearch {
	claimant: string;
	defendant: string;
	caseNumber: string;
	damageNumber: string;
	prosecutorsNotice: string;
	dataPTP: string;
	criminalCase: string;
	mvrNumber: string;
	enforcementCase: string;
	traumaType: Nomenclature;
	traumaTypeName: string;
	traumaText: string;
	uvajeni: boolean;
	data_suzd_inst_grdelo_ot: string;
	data_suzd_inst_grdelo_do: string;
	responsible: number;
	traumaTypeId: number;
}


